import React from 'react'
import {Box, Button, Grid, Modal, Stack, Typography} from "@mui/material";
import CourtEntity from "../../../courts/entities/court.entity";
import {Colors} from "../../../common/theme";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import PaidIcon from '@mui/icons-material/Paid';
import Paddle from './assets/paddle.svg'
import {getImageForCourtType} from "../map/map.view";



interface ICourtPopupViewModel {
  isOpen: boolean
  court: CourtEntity
  onClose: () => void
  onAddToFavorites: (court: CourtEntity) => void
  onViewInApp: (court: CourtEntity) => void
}

const CourtPopupView: React.FC<ICourtPopupViewModel> = (props) => {
  const renderedProps = props.court.renderedProps
  return (
    <Modal
      open={props.isOpen}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>

        <Carousel showThumbs={false}>
          {props.court.images.map((image) => (
            <img style={{width: '100%', height: 200, objectFit: 'cover'}} src={image} alt='' />
          ))}
        </Carousel>
        {props.court.images.length > 0 && <Box sx={{mb: 2}} />}

        <Typography id="modal-modal-title" variant="h6" component="h2">
          {props.court.name}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 1, color: Colors.black.c50 }}>
          <span style={{color: Colors.purple.main }}>{renderedProps.courtType}</span> | {renderedProps.playLocation}
        </Typography>
        <Typography id="modal-modal-description" sx={{ color: Colors.black.c40, fontSize: 14 }}>
          {props.court.address}
        </Typography>
        <Grid container spacing={2} mt={1}>
          <Grid item>
            <Stack direction={'row'} spacing={1}>
              <img src={Paddle} style={{width: 24}} alt='' />
              <Typography>{props.court.courts} {props.court.courts === 1 ? 'court' : 'courts'}</Typography>
            </Stack>
          </Grid>
          <Grid item>
            <Stack direction={'row'} spacing={1}>
              <PaidIcon fill={Colors.black.c30} />
              <Typography>{props.court.hasMembership ? 'Requires Membership' : 'Free'}</Typography>
            </Stack>
          </Grid>
          <Grid item>
            <Stack direction={'row'} spacing={1}>
              <LightbulbIcon fill={Colors.black.c30} />
              <Typography>{props.court.hasLighting ? 'Has Lighting' : 'No Lighting'}</Typography>
            </Stack>
          </Grid>
          <Grid item>
            <Stack direction={'row'} spacing={1}>
              <img src={getImageForCourtType(props.court.playLocation)} style={{width: 24, height: 24}} alt='' />
              <Typography>{props.court.playLocation === 'both' ? 'indoor & outdoor' : props.court.playLocation} </Typography>
            </Stack>
          </Grid>
        </Grid>

        <Button
          fullWidth
          sx={{
            mt: 2
          }}
          onClick={() => {
            props.onViewInApp(props.court)
          }}
        >
          Get Directions
        </Button>

        <Button onClick={() => {
          props.onViewInApp(props.court)
        }} fullWidth sx={{
          mt: 1
        }}>
          Review
        </Button>

        <Button
          sx={{
            mt: 1
          }}
          fullWidth
          onClick={() => {
            props.onAddToFavorites(props.court)
          }}
          variant={'contained'}>Add Court To Favorites</Button>
      </Box>
    </Modal>
  )
}

export default CourtPopupView

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 400,
  bgcolor: 'background.paper',
  border: `1px solid ${Colors.border}`,
  boxShadow: 24,
  borderRadius: 1,
  p: 4,
};
